import { RESET_RESPONSE_APPOINTMENT } from "./types";
import {
  SET_APPOINTMENT_DETAILS,
  SET_TELE_APPOINTMENT_LOADED
} from "./types";

const initialState = {
  Application_Number: "",
  isLoaded: false,
  AppointmentBookings: []
};

const teleAppointmentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_TELE_APPOINTMENT_LOADED:
      return { 
        ...state,
        isLoaded: payload,
        }
    case SET_APPOINTMENT_DETAILS:
      return { 
        ...state,
        Application_Number:  payload?.Application_Number,
        AppointmentBookings: [...payload?.Insured_Info],
        }
    case RESET_RESPONSE_APPOINTMENT:
      return { ...initialState }
    default:
      return state;
  }
};

export default teleAppointmentReducer;
